"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FilterSelectorActionTypes;
(function (FilterSelectorActionTypes) {
    FilterSelectorActionTypes[FilterSelectorActionTypes["SET_STATE"] = 0] = "SET_STATE";
    FilterSelectorActionTypes[FilterSelectorActionTypes["TOGGLE_DISPLAY_SELECTS"] = 1] = "TOGGLE_DISPLAY_SELECTS";
    FilterSelectorActionTypes[FilterSelectorActionTypes["RESET_SELECTED"] = 2] = "RESET_SELECTED";
    FilterSelectorActionTypes[FilterSelectorActionTypes["SELECT"] = 3] = "SELECT";
    FilterSelectorActionTypes[FilterSelectorActionTypes["FILTER"] = 4] = "FILTER";
})(FilterSelectorActionTypes = exports.FilterSelectorActionTypes || (exports.FilterSelectorActionTypes = {}));
exports.select = function (payload) { return ({
    type: FilterSelectorActionTypes.SELECT,
    payload: payload,
}); };
exports.resetSelect = function (payload) { return ({
    type: FilterSelectorActionTypes.RESET_SELECTED,
    payload: payload,
}); };
exports.toggleDisplaySelects = function () { return ({
    type: FilterSelectorActionTypes.TOGGLE_DISPLAY_SELECTS,
}); };
exports.filter = function (payload) { return ({
    type: FilterSelectorActionTypes.FILTER,
    payload: payload,
}); };
exports.setState = function (payload) { return ({
    type: FilterSelectorActionTypes.SET_STATE,
    payload: payload,
}); };
